import { TranslationCode, TranslationItem } from '@app/@shared/@types/translation';

export const translationList: TranslationItem[] = [
  { name: 'English', code: TranslationCode.EN },
  { name: 'Deutsch', code: TranslationCode.DE },
  { name: 'Spanish', code: TranslationCode.ES },
  { name: 'Albanian', code: TranslationCode.SQ },
];
